/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MyAsiDocumentSystemInfoControllerService } from './services/my-asi-document-system-info-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MyAsiDocumentSystemInfoControllerService,
    ApiConfiguration
  ],
})
export class MyasiDocumentSysteminfoModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MyasiDocumentSysteminfoModule> {
    return {
      ngModule: MyasiDocumentSysteminfoModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MyasiDocumentSysteminfoModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MyasiDocumentSysteminfoModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
